import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import myntraLogo from '../../images/myntra.png';
import airtelLogo from '../../images/airtel.png';
import {
  useWindowSize,
  useWindowWidth,
  useWindowHeight,
} from '@react-hook/window-size/throttled';
export const BrandsList = () => {
  return (
    <div className="brands-list">
      <h6>India's largest brands trusts us</h6>
      <ul>
        {['pb', 'quickfix', 'pbpartner', 'paisabazaar', 'visit'].map(
          (item, index) => (
            <li>
              <img
                key={item}
                src={require(`../../images/${item}.png`)}
                alt="logo"
              />
            </li>
          )
        )}
      </ul>
    </div>
  );
};
const SignUpContent = (props) => {
  const { anim } = props;
  const [width] = useWindowSize();
  return (
    <Wrapper className="content-box-wrapper">
      <span className="heading">
        <b>Supercharge your payment experience </b> <br /> with PB Pay.
      </span>
      <p className="sub-title">
        Payment solutions built to work for your business
      </p>
      <ul className="supercharge-list">
        <li>
          <FontAwesomeIcon icon={faCheck} /> Quick onboarding
        </li>
        <li>
          <FontAwesomeIcon icon={faCheck} /> High success rate
        </li>
        <li>
          <FontAwesomeIcon icon={faCheck} /> Effortless integration
        </li>
      </ul>
      {/* {width > 768 && <BrandsList />} */}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  height: 100%;
`;

export default SignUpContent;
